export default "__VITE_ASSET__C6DYEBFx__"